import type { TweetResponseEngagementAllOf } from './tweetResponseEngagementAllOf';
import type { TweetResponseEngagementAllOfTwo } from './tweetResponseEngagementAllOfTwo';

export type TweetResponseEngagement = TweetResponseEngagementAllOf & TweetResponseEngagementAllOfTwo;
